import * as React from 'react';
import { SendResult } from '../CharityDataForm/CharityDataForm';

const Notification = ({ variant, text }: SendResult): JSX.Element => {
  const styles: React.CSSProperties = {
    backgroundColor: 'rgb(25, 134, 85)',
    padding: '16px',
    color: 'white',
    borderRadius: '0.25rem'
  };
  if (variant === 'error') {
    styles.backgroundColor = 'rgb(220,53,69)';
  }

  const props: { style: React.CSSProperties } = { style: styles };
  return <div {...props}>{text}</div>;
};

export default Notification;
